import indicators from "./integrated-circuit-indicators.json";

export const INTEGRATED_CIRCUIT_CORE_REQUIRED_INDICATOR_IDS = [1, 7, 11, 14, 15, 18, 19];
export default indicators;
